import React from 'react';

const PageHeader: React.FC = () => {
  return (
    <header className="h-16 bg-gradient-to-r from-[#6673f3] to-[#32ace8] px-5">
      <div className="flex h-full items-center text-2xl font-semibold text-white">
        EAC
      </div>
    </header>
  );
};

export default PageHeader;
